export default __webpack_public_path__ + "static/media/warbler.ba03e263.png";